module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray-4302c5f81ed20242dcf2d6a66c05139e.png";